const initialState = { 
  loading: false,
  success: null,
  error: null
}

function deleteCategoryReducer(state = initialState, action) {
  switch (action.type) {
    case 'DELETE_CATEGORY_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'DELETE_CATEGORY_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'DELETE_CATEGORY_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default deleteCategoryReducer